import {ChangeDetectionStrategy, Component, Injectable, signal} from '@angular/core';
import {BrukerRessursClient, EnkelBrukerModell} from 'felles-ng2/tjenester/ressurser/generertNg2HttpKlient';
import {AdministrasjonBrukerKomponent} from '../administrasjon-bruker/administrasjon-bruker';
import {AdministrasjonNavigasjonKomponent} from '../administrasjon-navigasjon/administrasjon-navigasjon';

@Component({
    selector: 'administrasjon-brukere-side',
    templateUrl: 'administrasjon-brukere-side.html',
    styleUrl: 'administrasjon-brukere-side.scss',
    host: {'data-testid': 'administrasjon-brukere-side'},
    imports: [AdministrasjonNavigasjonKomponent, AdministrasjonBrukerKomponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdministrasjonBrukereSideKomponent {
    static ajsSelector = 'administrasjonBrukereSide';

    readonly brukere = signal<EnkelBrukerModell[]>([]);

    constructor(private avhengigheter: AdministrasjonBrukereSideAvhengigheter) {
        void this.lastBrukere();
    }

    async lastBrukere(): Promise<void> {
        this.brukere.set(await this.avhengigheter.finnAlle());
    }
}

@Injectable({providedIn: 'root'})
export class AdministrasjonBrukereSideAvhengigheter {
    constructor(private brukerRessurs: BrukerRessursClient) {}

    finnAlle(): Promise<EnkelBrukerModell[]> {
        return this.brukerRessurs.finnAlle().somPromise();
    }
}
